import { useParams } from "react-router-dom";
import { getLocalStorageData } from "../../utils/LocalStorageService";
import { useDispatch } from "react-redux";
import { useCallback, useEffect, useState } from "react";
import { ACTION_TYPE, REPORT_NAME, REPORT_PATH } from "../constant/reportType";
import { Button, Form } from "react-bootstrap";
import { Switch, Table, DatePicker } from "antd";
import { BsPencilSquare, BsPlus, BsSearch } from "react-icons/bs";
import { useAppSelector } from "../../redux-toolkit/hooks";
import Loading from "../Loading";
import { alertMessage } from "../../utils/AlertService";
import { useDeleteVoucherTypeFinanceMasterMutation, useGetAllVoucherTypeFinanceMasterMutation, useSearchVoucherTypeFinanceMasterMutation } from "../../redux-toolkit/services/voucherTypeFinanceMasterService";
import { useDeleteVoucherTypeKarmaMasterMutation, useGetAllVoucherTypeKarmaMasterMutation, useSearchVoucherTypeKarmaMasterMutation } from "../../redux-toolkit/services/voucherTypeKarmaMasterService";
import { getVoucherTypeFinanceMasterBySearch, getVoucherTypeFinanceMasterData, getVoucherTypeFinanceMasterTotalRecords, setVoucherTypeFinanceMaster, setVoucherTypeFinanceMasterBySearch } from "../../redux-toolkit/slices/voucherTypeFinanceMasterSlice";
import { getVoucherTypeKarmaMasterBySearch, getVoucherTypeKarmaMasterData, getVoucherTypeKarmaMasterTotalRecords, setVoucherTypeKarmaMaster, setVoucherTypeKarmaMasterBySearch } from "../../redux-toolkit/slices/voucherTypeKarmaMasterSlice";
import { PARTY_CATEGORY_MASTER_COLUMN, VOUCHER_FINANCE_COLUMN, VOUCHER_KARMA_COLUMN, VOUCHER_PARTICIPANT_COLUMN, VOUCHER_TYPE_MASTER_COLUMN } from "../constant/AppConstant";
import VoucherTransactionReportData from "./VoucherTransactionReportData";
import { useDeleteVoucherFinanceMutation, useGetAllVoucherFinanceMutation, useSearchVoucherFinanceMutation } from "../../redux-toolkit/services/voucherFinanceService";
import { useDeleteVoucherKarmaMutation, useGetAllVoucherKarmaMutation, useSearchVoucherKarmaMutation } from "../../redux-toolkit/services/voucherKarmaService";
import { getVoucherFinanceData, getVoucherFinanceDataBySearch, getVoucherFinanceTotalRecords, setVoucherFinance, setVoucherFinanceBySearch } from "../../redux-toolkit/slices/voucherFinanceSlice";
import { getVoucherKarmaDataBySearch, getVoucherKarmaTotalRecords, setVoucherKarma, setVoucherKarmaBySearch } from "../../redux-toolkit/slices/voucherKarmaSlice";
import { getVoucherParticipantBySearchDetails, getVoucherParticipantDetails, getVoucherParticipantTotalRecords, setVoucherParticipant, setVoucherParticipantBySearch } from "../../redux-toolkit/slices/voucherParticipantSlice";
import { useDeleteVoucherParticipantMutation, useGetAllVoucherParticipantBySearchMutation, useGetAllVoucherParticipantMutation } from "../../redux-toolkit/services/voucherParticipantService";
import { useSaveAuditLogMutation } from "../../redux-toolkit/services/auditLogService";
import { useDeletePartyCategoryMasterMutation, useGetAllPartyCategoryMasterBySearchMutation, useGetAllPartyCategoryMasterMutation } from "../../redux-toolkit/services/partyCategoryMasterService";
import { getPartyCategoryMasterBySearchDetails, getPartyCategoryMasterDetails, getPartyCategoryTotalRecords, setPartyCategoryMaster, setPartyCategoryMasterBySearch } from "../../redux-toolkit/slices/partyCategoryMasterSlice";
import type { Dayjs } from "dayjs";
const { RangePicker } = DatePicker;


type Props = {};
const VoucherTransactionReports = (props: Props) => {

    const params = useParams();
    const localUserObj: any = getLocalStorageData("localUser");
    const token: any = getLocalStorageData("localUser").token;
    const dispatch = useDispatch();

    //state
    const [actionType, setActionType] = useState(ACTION_TYPE.ADD_ACTION) as any;
    const [reportName, setReportName]: any = useState();
    const [currentpage, setCurrentPage] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [show, setShow] = useState(false);
    const [selectedRow, setSelectedRow]: any = useState([]);
    const [columData, setColumnData]: any = useState();
    const [dataSource, setDatasource]: any = useState([]);
    const [call, setCall] = useState("N");
    const [dateRange, setDateRange] = useState<[Dayjs | null, Dayjs | null]>([null, null]);
    const [searchText, setSearchText] = useState("");


    //getMutations
    const [getAllVoucherTypeFinanceMasterWithPagination, getAllVoucherTypeFinanceMasterWithPaginationResponse] = useGetAllVoucherTypeFinanceMasterMutation();
    const [getAllVoucherTypeKarmaMasterWithPagination, getAllVoucherTypeKarmaMasterWithPaginationResponse] = useGetAllVoucherTypeKarmaMasterMutation();
    const [getAllVoucherFinanceWithPagination, getAllVoucherFinanceWithPaginationResponse] = useGetAllVoucherFinanceMutation();
    const [getAllVoucherKarmaWithPagination, getAllVoucherKarmaWithPaginationResponse] = useGetAllVoucherKarmaMutation();
    const [getAllVoucherParticipantWithPagination, getAllVoucherParticipantWithPaginationResponse] = useGetAllVoucherParticipantMutation()
    const [getAllPartyCategoryMasterWithPagination, getAllPartyCategoryMasterWithPaginationResponse] = useGetAllPartyCategoryMasterMutation()
    //get by search
    const [getVoucherTypeKarmaMastersBySearch, getVoucherTypeKarmaMastersBySearchResponse] = useSearchVoucherTypeKarmaMasterMutation();
    const [getVoucherTypeFinanceMastersBySearch, getVoucherTypeFinanceMastersBySearchResponse] = useSearchVoucherTypeFinanceMasterMutation();
    const [getVoucherTypeKarmaBySearch, getVoucherTypeKarmaBySearchResponse] = useSearchVoucherKarmaMutation();
    const [getVoucherTypeFinanceBySearch, getVoucherTypeFinanceBySearchResponse] = useSearchVoucherFinanceMutation();
    const [getVoucherParticipantSearch, getVoucherParticipantBySearchResponse] = useGetAllVoucherParticipantBySearchMutation();
    const [getAllPartyCategoryMasterSearch, getAllPartyCategoryMasterBySearchResponse] = useGetAllPartyCategoryMasterBySearchMutation();
    //delete mutation  
    const [deleteVoucherTypeKarmaMaster, deleteVoucherTypeKarmaMasterResponse] = useDeleteVoucherTypeKarmaMasterMutation()
    const [deleteVoucherTypeFinanceMaster, deleteVoucherTypeFinanceMasterResponse] = useDeleteVoucherTypeFinanceMasterMutation()
    const [deleteVoucherKarma, deleteVoucherKarmaResponse] = useDeleteVoucherKarmaMutation();
    const [deleteVoucherFinance, deleteVoucherFinanceResponse] = useDeleteVoucherFinanceMutation();
    const [deleteVoucherParticipant, deleteVoucherParticipantResponse] = useDeleteVoucherParticipantMutation();
    const [deletePartyCategoryMaster, deletePartyCategoryMasterResponse] = useDeletePartyCategoryMasterMutation();

    // save
    const [logAudit] = useSaveAuditLogMutation();


    //totalRecords
    const totalVoucherTypeFinanceMaster: any = useAppSelector(getVoucherTypeFinanceMasterTotalRecords)
    const totalVoucherTypeKarmaMaster: any = useAppSelector(getVoucherTypeKarmaMasterTotalRecords)
    const totalVoucherFinance: any = useAppSelector(getVoucherFinanceTotalRecords)
    const totalVouchereKarma: any = useAppSelector(getVoucherKarmaTotalRecords)
    const totalVoucherParticipant: any = useAppSelector(getVoucherParticipantTotalRecords)
    const totalPartyCategoryMaster: any = useAppSelector(getPartyCategoryTotalRecords)

    //selector
    const voucherTypeKarmaMasterSearchData: any = useAppSelector(getVoucherTypeKarmaMasterBySearch);
    const VoucherTypeKarmaMasterData: any = useAppSelector(getVoucherTypeKarmaMasterData);
    const VoucherTypeFinanceMasterSearchData: any = useAppSelector(getVoucherTypeFinanceMasterBySearch);
    const VoucherTypeFinanceMasterData: any = useAppSelector(getVoucherTypeFinanceMasterData);
    const VoucherFinanceSearchData: any = useAppSelector(getVoucherFinanceDataBySearch);
    const VoucherFinanceData: any = useAppSelector(getVoucherFinanceData);
    const voucherKarmaSearchData: any = useAppSelector(getVoucherKarmaDataBySearch);
    const VoucherKarmaData: any = useAppSelector(getVoucherTypeKarmaMasterBySearch);
    const VoucherParticipantSearchData: any = useAppSelector(getVoucherParticipantBySearchDetails);
    const VoucherParticipantData: any = useAppSelector(getVoucherParticipantDetails);
    const partyCategorySearchData: any = useAppSelector(getPartyCategoryMasterBySearchDetails);
    const partyCategoryData: any = useAppSelector(getPartyCategoryMasterDetails);


    useEffect(() => {
        switch (params.reportType) {
            case REPORT_PATH.VOUCHER_TYPE_MASTER_FINANCE:
                setReportName(REPORT_NAME.VOUCHER_TYPE_MASTER_FINANCE)
                break;
            case REPORT_PATH.VOUCHER_TYPE_MASTER_KARMA:
                setReportName(REPORT_NAME.VOUCHER_TYPE_MASTER_KARMA)
                break;
            case REPORT_PATH.VOUCHER_FINANCE:
                setReportName(REPORT_NAME.VOUCHER_FINANCE)
                break;
            case REPORT_PATH.VOUCHER_KARMA:
                setReportName(REPORT_NAME.VOUCHER_KARMA)
                break;
            case REPORT_PATH.VOUCHER_PARTICIPANT:
                setReportName(REPORT_NAME.VOUCHER_PARTICIPANT)
                break;
            case REPORT_PATH.PARTY_CATEGORY_MASTER:
                setReportName(REPORT_NAME.PARTY_CATEGORY_MASTER)
                break;
            default:
        }
    }, [params.reportType]);




    useEffect(() => {
        const temp: any = [];
        const tempAction: any = {
            title: "Action",
            dataIndex: "action",
            key: "name",
            fixed: "right",
            width: 120,
            render: (index: any, record: any) => {
                return (
                    <div className="d-flex justify-content-between">
                        <div className="px-2 pe-auto">
                            <Switch
                                className={`${record.status === true ||
                                    record.enabled === true ||
                                    record.isActive === true ? "bg-accent" : "bg-secondry"}`}
                                checked={
                                    record.status === true ||
                                        record.enabled === true ||
                                        record.isActive === true
                                        ? true
                                        : false
                                }
                                onClick={() => {
                                    onDeleteData(record);
                                }}
                            />
                        </div>
                        {record.status === true ||
                            record.enabled === true ||
                            record.isActive === true ? (
                            <div
                                className="px-2 pe-auto"
                                onClick={() => {
                                    handleOpenForm(record);
                                }}
                            >
                                <BsPencilSquare size={18} />
                            </div>
                        ) : null}
                    </div>
                );
            },
        };

        if ((reportName === REPORT_NAME.VOUCHER_TYPE_MASTER_FINANCE || reportName === REPORT_NAME.VOUCHER_TYPE_MASTER_KARMA) && VOUCHER_TYPE_MASTER_COLUMN) {
            VOUCHER_TYPE_MASTER_COLUMN.map((item: any) => {
                temp.push(item);
            });
            temp.push(tempAction);
            setColumnData(temp);
        } else if (reportName === REPORT_NAME.VOUCHER_FINANCE && VOUCHER_FINANCE_COLUMN) {
            VOUCHER_FINANCE_COLUMN.map((item: any) => {
                temp.push(item);
            });
            temp.push(tempAction);
            setColumnData(temp);
        } else if (reportName === REPORT_NAME.VOUCHER_KARMA && VOUCHER_KARMA_COLUMN) {
            VOUCHER_KARMA_COLUMN.map((item: any) => {
                temp.push(item);
            });
            temp.push(tempAction);
            setColumnData(temp);
        } else if (reportName === REPORT_NAME.VOUCHER_PARTICIPANT && VOUCHER_PARTICIPANT_COLUMN) {
            VOUCHER_PARTICIPANT_COLUMN.map((item: any) => {
                temp.push(item);
            });
            temp.push(tempAction);
            setColumnData(temp);
        }
        else if (reportName === REPORT_NAME.PARTY_CATEGORY_MASTER && PARTY_CATEGORY_MASTER_COLUMN) {
            PARTY_CATEGORY_MASTER_COLUMN.map((item: any) => {
                temp.push(item);
            });
            temp.push(tempAction);
            setColumnData(temp);
        }
    }, [reportName, params.reportType]);

    useEffect(() => {
        if (reportName === REPORT_NAME.VOUCHER_TYPE_MASTER_FINANCE) {
            getAllVoucherTypeFinanceMasterWithPagination({
                token: token,
                payload: {
                    size: pageSize,
                    page: currentpage - 1,
                    orderBy: "desc"
                }
            });
        } else if (reportName === REPORT_NAME.VOUCHER_TYPE_MASTER_KARMA) {
            getAllVoucherTypeKarmaMasterWithPagination({
                token: token,
                payload: {
                    size: pageSize,
                    page: currentpage - 1,
                    orderBy: "desc"
                }
            });
        }
        else if (reportName === REPORT_NAME.VOUCHER_FINANCE) {
            getAllVoucherFinanceWithPagination({
                token: token,
                payload: {
                    size: pageSize,
                    page: currentpage - 1,
                    orderBy: "desc"
                }
            });
        }
        else if (reportName === REPORT_NAME.VOUCHER_KARMA) {
            getAllVoucherKarmaWithPagination({
                token: token,
                payload: {
                    size: pageSize,
                    page: currentpage - 1,
                    orderBy: "desc"
                }
            });
        }
        else if (reportName === REPORT_NAME.VOUCHER_PARTICIPANT) {
            getAllVoucherParticipantWithPagination({
                token: token,
                payload: {
                    size: pageSize,
                    page: currentpage - 1,
                    orderBy: "desc"
                }
            });
        }
        else if (reportName === REPORT_NAME.PARTY_CATEGORY_MASTER) {
            getAllPartyCategoryMasterWithPagination({
                token: token,
                payload: {
                    size: pageSize,
                    page: currentpage - 1,
                    orderBy: "desc"
                }
            });
        }
    }, [reportName]);


    useEffect(() => {
        if (call === "Y") {
            if (reportName === REPORT_NAME.VOUCHER_TYPE_MASTER_FINANCE) {
                getAllVoucherTypeFinanceMasterWithPagination({
                    token,
                    payload: { size: pageSize, page: currentpage - 1, orderBy: "asc" }
                });
            } else if (reportName === REPORT_NAME.VOUCHER_TYPE_MASTER_KARMA) {
                getAllVoucherTypeKarmaMasterWithPagination({
                    token,
                    payload: { size: pageSize, page: currentpage - 1, orderBy: "asc" }
                });
            } else if (reportName === REPORT_NAME.VOUCHER_KARMA) {
                getAllVoucherKarmaWithPagination({
                    token,
                    payload: { size: pageSize, page: currentpage - 1, orderBy: "asc" }
                });
            } else if (reportName === REPORT_NAME.VOUCHER_FINANCE) {
                getAllVoucherFinanceWithPagination({
                    token,
                    payload: { size: pageSize, page: currentpage - 1, orderBy: "asc" }
                });
            }
            else if (reportName === REPORT_NAME.VOUCHER_PARTICIPANT) {
                getAllVoucherParticipantWithPagination({
                    token,
                    payload: { size: pageSize, page: currentpage - 1, orderBy: "asc" }
                });
            }
            else if (reportName === REPORT_NAME.PARTY_CATEGORY_MASTER) {
                getAllPartyCategoryMasterWithPagination({
                    token,
                    payload: { size: pageSize, page: currentpage - 1, orderBy: "asc" }
                });
            }
            setCall("N");
        }
    }, [call]);


    const paginationChange = (page: number, pageSize: number) => {
        if (reportName === REPORT_NAME.VOUCHER_TYPE_MASTER_FINANCE) {
            getAllVoucherTypeFinanceMasterWithPagination({
                token: token,
                payload: {
                    size: pageSize,
                    page: page - 1,
                    orderBy: "asc"
                }
            });
        } else if (reportName === REPORT_NAME.VOUCHER_TYPE_MASTER_KARMA) {
            getAllVoucherTypeKarmaMasterWithPagination({
                token: token,
                payload: {
                    size: pageSize,
                    page: page - 1,
                    orderBy: "asc"
                }
            });
        }
        else if (reportName === REPORT_NAME.VOUCHER_FINANCE) {
            getAllVoucherFinanceWithPagination({
                token: token,
                payload: {
                    size: pageSize,
                    page: page - 1,
                    orderBy: "asc"
                }
            });
        }
        else if (reportName === REPORT_NAME.VOUCHER_KARMA) {
            getAllVoucherKarmaWithPagination({
                token: token,
                payload: {
                    size: pageSize,
                    page: page - 1,
                    orderBy: "asc"
                }
            });
        }
        else if (reportName === REPORT_NAME.VOUCHER_PARTICIPANT) {
            getAllVoucherParticipantWithPagination({
                token: token,
                payload: {
                    size: pageSize,
                    page: page - 1,
                    orderBy: "asc"
                }
            });
        }
        else if (reportName === REPORT_NAME.PARTY_CATEGORY_MASTER) {
            getAllPartyCategoryMasterWithPagination({
                token: token,
                payload: {
                    size: pageSize,
                    page: page - 1,
                    orderBy: "asc"
                }
            });
        }
        setCurrentPage(page);
        setPageSize(pageSize);
    };

    const handleShow = () => {
        setActionType(ACTION_TYPE.ADD_ACTION);
        setShow(true)
    };

    const onDeleteData = (record: any) => {
        if (reportName === REPORT_NAME.VOUCHER_TYPE_MASTER_KARMA) {
            deleteVoucherTypeKarmaMaster({
                id: record.id,
                token: token,
            });

            const payload = {
                tableName: REPORT_NAME.VOUCHER_TYPE_MASTER_KARMA,
                recordId: record.id,
                operationType: "DELETE",
                oldValue: record,
                newValue: { ...record, isActive: !record.isActive },
            };

            logAudit({
                token: localUserObj?.token,
                payload: payload,
            });

        } else if (reportName === REPORT_NAME.VOUCHER_TYPE_MASTER_FINANCE) {
            deleteVoucherTypeFinanceMaster({
                id: record.id,
                token: token,
            });

            const payload = {
                tableName: REPORT_NAME.VOUCHER_TYPE_MASTER_FINANCE,
                recordId: record.id,
                operationType: "DELETE",
                oldValue: record,
                newValue: { ...record, isActive: !record.isActive },
            };

            logAudit({
                token: localUserObj?.token,
                payload: payload,
            });

        } else if (reportName === REPORT_NAME.VOUCHER_FINANCE) {
            deleteVoucherFinance({
                id: record.id,
                token: token,
            });

            const payload = {
                tableName: REPORT_NAME.VOUCHER_FINANCE,
                recordId: record.id,
                operationType: "DELETE",
                oldValue: record,
                newValue: { ...record, isActive: !record.isActive },
            };

            logAudit({
                token: localUserObj?.token,
                payload: payload,
            });

        } else if (reportName === REPORT_NAME.VOUCHER_KARMA) {
            deleteVoucherKarma({
                id: record.id,
                token: token,
            });

            const payload = {
                tableName: REPORT_NAME.VOUCHER_KARMA,
                recordId: record.id,
                operationType: "DELETE",
                oldValue: record,
                newValue: { ...record, isActive: !record.isActive },
            };

            logAudit({
                token: localUserObj?.token,
                payload: payload,
            });

        } else if (reportName === REPORT_NAME.VOUCHER_PARTICIPANT) {
            deleteVoucherParticipant({
                id: record.id,
                token: token,
            });

            const payload = {
                tableName: REPORT_NAME.VOUCHER_PARTICIPANT,
                recordId: record.id,
                operationType: "DELETE",
                oldValue: record,
                newValue: { ...record, isActive: !record.isActive },
            };

            logAudit({
                token: localUserObj?.token,
                payload: payload,
            });
        }

        else if (reportName === REPORT_NAME.PARTY_CATEGORY_MASTER) {
            deletePartyCategoryMaster({
                id: record.id,
                token: token,
            });

            const payload = {
                tableName: REPORT_NAME.PARTY_CATEGORY_MASTER,
                recordId: record.id,
                operationType: "DELETE",
                oldValue: record,
                newValue: { ...record, isActive: !record.isActive },
            };

            logAudit({
                token: localUserObj?.token,
                payload: payload,
            });
        }
    };

    useEffect(() => {
        if (deleteVoucherTypeKarmaMasterResponse.isSuccess) {
            if (deleteVoucherTypeKarmaMasterResponse.data?.isActive) {
                alertMessage("Voucher Type Master - Karma enabled successfully", "success");
            } else {
                alertMessage("Voucher Type Master - Karma deleted successfully", "success");
            }
            setCall("Y");
        } else if (deleteVoucherTypeKarmaMasterResponse.isError) {
            alertMessage("Error while deleting Voucher Type Master - Karma", "error");
        }
    }, [
        deleteVoucherTypeKarmaMasterResponse.isSuccess,
        deleteVoucherTypeKarmaMasterResponse.isError,

    ]);


    useEffect(() => {
        if (deleteVoucherParticipantResponse.isSuccess) {
            if (deleteVoucherParticipantResponse.data?.isActive) {
                alertMessage("Voucher Participant enabled successfully", "success");
            } else {
                alertMessage("Voucher Participant deleted successfully", "success");
            }
            setCall("Y");
        } else if (deleteVoucherParticipantResponse.isError) {
            alertMessage("Error while deleting Voucher Participant", "error");
        }
    }, [
        deleteVoucherParticipantResponse.isSuccess,
        deleteVoucherParticipantResponse.isError,
    ]);



    useEffect(() => {
        if (deleteVoucherKarmaResponse.isSuccess) {
            if (deleteVoucherKarmaResponse.data?.isActive) {
                alertMessage("Voucher - Karma enabled successfully", "success");
            } else {
                alertMessage("Voucher - Karma deleted successfully", "success");
            }
            setCall("Y");
        } else if (deleteVoucherKarmaResponse.isError) {
            alertMessage("Error while deleting Voucher - Karma", "error");
        }
    }, [
        deleteVoucherKarmaResponse.isSuccess,
        deleteVoucherKarmaResponse.isError,
    ]);

    useEffect(() => {
        if (deleteVoucherFinanceResponse.isSuccess) {
            if (deleteVoucherFinanceResponse.data?.isActive) {
                alertMessage("Voucher - Finance enabled successfully", "success");
            } else {
                alertMessage("Voucher - Finance deleted successfully", "success");
            }
            setCall("Y");
        } else if (deleteVoucherFinanceResponse.isError) {
            alertMessage("Error while deleting Voucher - Finance", "error");
        }
    }, [
        deleteVoucherFinanceResponse.isSuccess,
        deleteVoucherFinanceResponse.isError,
    ]);


    useEffect(() => {
        if (deleteVoucherTypeFinanceMasterResponse.isSuccess) {
            if (deleteVoucherTypeFinanceMasterResponse.data?.isActive) {
                alertMessage("Voucher Type Master - Finance enabled successfully", "success");
            } else {
                alertMessage("Voucher Type Master - Finance deleted successfully", "success");
            }
            setCall("Y");
        } else if (deleteVoucherTypeFinanceMasterResponse.isError) {
            alertMessage("Error while deleting Voucher Type Master - Finance", "error");
        }
    }, [
        deleteVoucherTypeFinanceMasterResponse.isSuccess,
        deleteVoucherTypeFinanceMasterResponse.isError,
    ]);

    useEffect(() => {
        if (deletePartyCategoryMasterResponse.isSuccess) {
            if (deletePartyCategoryMasterResponse.data?.isActive) {
                alertMessage("Party Category Master enabled successfully", "success");
            } else {
                alertMessage("Party Category Master deleted successfully", "success");
            }
            setCall("Y");
        } else if (deletePartyCategoryMasterResponse.isError) {
            alertMessage("Error while deleting Party Category Master", "error");
        }
    }, [
        deletePartyCategoryMasterResponse.isSuccess,
        deletePartyCategoryMasterResponse.isError,
    ]);


    const handleOpenForm = (record: any) => {
        setActionType(ACTION_TYPE.UPDATE_ACTION);
        setSelectedRow(record);
        setShow(true);
    };




    const handleFilterChange = (
        params: { searchText?: string; dateRange?: [Dayjs | null, Dayjs | null] }
    ) => {
        const newSearchText = params.searchText !== undefined ? params.searchText : searchText;
        const newDateRange = params.dateRange !== undefined ? params.dateRange : dateRange;

        setSearchText(newSearchText);
        setDateRange(newDateRange);

        const fromDate = newDateRange?.[0] ? newDateRange[0]?.format("YYYY-MM-DD") : "";
        const toDate = newDateRange?.[1] ? newDateRange[1]?.format("YYYY-MM-DD") : "";

        const payload = {
            offset: 1000,
            pageNumber: 0,
            searchBy: newSearchText,
            fromDate,
            toDate,
        };

        switch (reportName) {
            case REPORT_NAME.VOUCHER_TYPE_MASTER_KARMA:
                getVoucherTypeKarmaMastersBySearch({
                    token: localUserObj?.token,
                    payload: { offset: 1000, pageNumber: 0, searchBy: newSearchText },
                });
                break;
            case REPORT_NAME.VOUCHER_TYPE_MASTER_FINANCE:
                getVoucherTypeFinanceMastersBySearch({
                    token: localUserObj?.token,
                    payload: { offset: 1000, pageNumber: 0, searchBy: newSearchText },
                });
                break;
            case REPORT_NAME.VOUCHER_FINANCE:
                getVoucherTypeFinanceBySearch({
                    token: localUserObj?.token,
                    payload: { offset: 1000, pageNumber: 0, searchBy: newSearchText, fromDate, toDate },
                });
                break;
            case REPORT_NAME.VOUCHER_KARMA:
                getVoucherTypeKarmaBySearch({
                    token: localUserObj?.token,
                    payload: { offset: 1000, pageNumber: 0, searchBy: newSearchText, fromDate, toDate },
                });
                break;
            case REPORT_NAME.VOUCHER_PARTICIPANT:
                getVoucherParticipantSearch({
                    token: localUserObj?.token,
                    payload: { offset: 1000, pageNumber: 0, searchBy: newSearchText },
                });
                break;
            case REPORT_NAME.PARTY_CATEGORY_MASTER:
                getAllPartyCategoryMasterSearch({
                    token: localUserObj?.token,
                    payload: { offset: 1000, pageNumber: 0, searchBy: newSearchText },
                });
                break;
            default:
                break;
        }
    };



    useEffect(() => {
        if (getVoucherTypeFinanceMastersBySearchResponse.isSuccess) {
            console.log(getVoucherTypeFinanceMastersBySearchResponse, "getVoucherTypeFinanceMastersBySearchResponse");
            dispatch(setVoucherTypeFinanceMasterBySearch(getVoucherTypeFinanceMastersBySearchResponse));
        } else if (getVoucherTypeFinanceMastersBySearchResponse.isError) {
            let response: any = getVoucherTypeFinanceMastersBySearchResponse.error;
            alertMessage(response, "error");
        }
    }, [getVoucherTypeFinanceMastersBySearchResponse.isSuccess, getVoucherTypeFinanceMastersBySearchResponse.isError]);

    useEffect(() => {
        if (getVoucherTypeKarmaMastersBySearchResponse.isSuccess) {
            dispatch(setVoucherTypeKarmaMasterBySearch(getVoucherTypeKarmaMastersBySearchResponse));
        } else if (getVoucherTypeKarmaMastersBySearchResponse.isError) {
            let response: any = getVoucherTypeKarmaMastersBySearchResponse.error;
            alertMessage(response, "error");
        }
    }, [getVoucherTypeKarmaMastersBySearchResponse.isSuccess, getVoucherTypeKarmaMastersBySearchResponse.isError]);

    useEffect(() => {
        if (getAllPartyCategoryMasterBySearchResponse.isSuccess) {
            dispatch(setPartyCategoryMasterBySearch(getAllPartyCategoryMasterBySearchResponse));
        } else if (getAllPartyCategoryMasterBySearchResponse.isError) {
            let response: any = getAllPartyCategoryMasterBySearchResponse.error;
            alertMessage(response, "error");
        }
    }, [getAllPartyCategoryMasterBySearchResponse.isSuccess, getAllPartyCategoryMasterBySearchResponse.isError]);


    useEffect(() => {
        if (getAllVoucherTypeFinanceMasterWithPaginationResponse.isSuccess) {
            dispatch(setVoucherTypeFinanceMaster(getAllVoucherTypeFinanceMasterWithPaginationResponse));
        } else if (getAllVoucherTypeFinanceMasterWithPaginationResponse.isError) {
            let response: any = getAllVoucherTypeFinanceMasterWithPaginationResponse.error;
            alertMessage(response, "error");
        }
    }, [getAllVoucherTypeFinanceMasterWithPaginationResponse.isSuccess, getAllVoucherTypeFinanceMasterWithPaginationResponse.isError]);

    useEffect(() => {
        if (getAllVoucherTypeKarmaMasterWithPaginationResponse.isSuccess) {
            dispatch(setVoucherTypeKarmaMaster(getAllVoucherTypeKarmaMasterWithPaginationResponse));
        } else if (getAllVoucherTypeKarmaMasterWithPaginationResponse.isError) {
            let response: any = getAllVoucherTypeKarmaMasterWithPaginationResponse.error;
            alertMessage(response, "error");
        }
    }, [getAllVoucherTypeKarmaMasterWithPaginationResponse.isSuccess, getAllVoucherTypeKarmaMasterWithPaginationResponse.isError]);


    useEffect(() => {
        if (getAllVoucherFinanceWithPaginationResponse.isSuccess) {
            dispatch(setVoucherFinance(getAllVoucherFinanceWithPaginationResponse));
        } else if (getAllVoucherFinanceWithPaginationResponse.isError) {
            let response: any = getAllVoucherFinanceWithPaginationResponse.error;
            alertMessage("Error while fetching Voucher Finance list", "error");
        }
    }, [
        getAllVoucherFinanceWithPaginationResponse.isSuccess,
        getAllVoucherFinanceWithPaginationResponse.isError
    ]);

    useEffect(() => {
        if (getAllVoucherKarmaWithPaginationResponse.isSuccess) {
            dispatch(setVoucherKarma(getAllVoucherKarmaWithPaginationResponse));
        } else if (getAllVoucherKarmaWithPaginationResponse.isError) {
            let response: any = getAllVoucherKarmaWithPaginationResponse.error;
            alertMessage(response, "error");
            alertMessage("Error while fetching Voucher Karma list", "error");
        }
    }, [
        getAllVoucherKarmaWithPaginationResponse.isSuccess,
        getAllVoucherKarmaWithPaginationResponse.isError
    ]);

    useEffect(() => {
        if (getAllPartyCategoryMasterWithPaginationResponse.isSuccess) {
            dispatch(setPartyCategoryMaster(getAllPartyCategoryMasterWithPaginationResponse));
        } else if (getAllPartyCategoryMasterWithPaginationResponse.isError) {
            let response: any = getAllPartyCategoryMasterWithPaginationResponse.error;
            alertMessage(response, "error");
        }
    }, [
        getAllPartyCategoryMasterWithPaginationResponse.isSuccess,
        getAllPartyCategoryMasterWithPaginationResponse.isError
    ]);

    // Voucher Finance - Search
    useEffect(() => {
        if (getVoucherTypeFinanceBySearchResponse.isSuccess) {
            dispatch(setVoucherFinanceBySearch(getVoucherTypeFinanceBySearchResponse));
        } else if (getVoucherTypeFinanceBySearchResponse.isError) {
            let response: any = getVoucherTypeFinanceBySearchResponse.error;
            alertMessage(response, "error");
        }
    }, [
        getVoucherTypeFinanceBySearchResponse.isSuccess,
        getVoucherTypeFinanceBySearchResponse.isError
    ]);

    useEffect(() => {
        if (getVoucherTypeKarmaBySearchResponse.isSuccess) {
            dispatch(setVoucherKarmaBySearch(getVoucherTypeKarmaBySearchResponse));
        } else if (getVoucherTypeKarmaBySearchResponse.isError) {
            let response: any = getVoucherTypeKarmaBySearchResponse.error;
            alertMessage(response, "error");
        }
    }, [
        getVoucherTypeKarmaBySearchResponse.isSuccess,
        getVoucherTypeKarmaBySearchResponse.isError
    ]);


    useEffect(() => {
        if (getVoucherParticipantBySearchResponse.isSuccess) {
            dispatch(setVoucherParticipantBySearch(getVoucherParticipantBySearchResponse));
        } else if (getVoucherParticipantBySearchResponse.isError) {
            let response: any = getVoucherParticipantBySearchResponse.error;
            alertMessage(response, "error");
        }
    }, [
        getVoucherParticipantBySearchResponse.isSuccess,
        getVoucherParticipantBySearchResponse.isError
    ]);

    useEffect(() => {
        if (getAllVoucherParticipantWithPaginationResponse.isSuccess) {
            dispatch(setVoucherParticipant(getAllVoucherParticipantWithPaginationResponse));
        } else if (getAllVoucherParticipantWithPaginationResponse.isError) {
            let response: any = getAllVoucherParticipantWithPaginationResponse.error;
            alertMessage(response, "error");
        }
    }, [
        getAllVoucherParticipantWithPaginationResponse.isSuccess,
        getAllVoucherParticipantWithPaginationResponse.isError
    ]);



    useEffect(() => {
        if (voucherTypeKarmaMasterSearchData && reportName === REPORT_NAME.VOUCHER_TYPE_MASTER_KARMA) {
            setDatasource(voucherTypeKarmaMasterSearchData);
        }
    }, [voucherTypeKarmaMasterSearchData]);

    useEffect(() => {
        if (VoucherTypeFinanceMasterSearchData && reportName === REPORT_NAME.VOUCHER_TYPE_MASTER_FINANCE) {
            setDatasource(VoucherTypeFinanceMasterSearchData);
        }
    }, [VoucherTypeFinanceMasterSearchData]);


    useEffect(() => {
        if (voucherKarmaSearchData && reportName === REPORT_NAME.VOUCHER_KARMA) {
            setDatasource(voucherKarmaSearchData);
        }
    }, [voucherKarmaSearchData]);

    useEffect(() => {
        if (VoucherFinanceSearchData && reportName === REPORT_NAME.VOUCHER_FINANCE) {
            setDatasource(VoucherFinanceSearchData);
        }
    }, [VoucherFinanceSearchData]);

    useEffect(() => {
        if (VoucherParticipantSearchData && reportName === REPORT_NAME.VOUCHER_PARTICIPANT) {
            setDatasource(VoucherParticipantSearchData);
        }
    }, [VoucherParticipantSearchData]);

    useEffect(() => {
        if (partyCategorySearchData && reportName === REPORT_NAME.PARTY_CATEGORY_MASTER) {
            setDatasource(partyCategorySearchData);
        }
    }, [partyCategorySearchData]);



    useEffect(() => {
        if (VoucherParticipantData && reportName === REPORT_NAME.VOUCHER_PARTICIPANT) {
            setDatasource(VoucherParticipantData);
        }
    }, [VoucherParticipantData]);



    useEffect(() => {
        if (VoucherTypeFinanceMasterData && reportName === REPORT_NAME.VOUCHER_TYPE_MASTER_FINANCE) {
            setDatasource(VoucherTypeFinanceMasterData);
        }
    }, [VoucherTypeFinanceMasterData]);


    useEffect(() => {
        if (VoucherTypeKarmaMasterData && reportName === REPORT_NAME.VOUCHER_TYPE_MASTER_KARMA) {
            setDatasource(VoucherTypeKarmaMasterData);
        }
    }, [VoucherTypeKarmaMasterData]);


    useEffect(() => {
        if (VoucherFinanceData && reportName === REPORT_NAME.VOUCHER_FINANCE) {
            setDatasource(VoucherFinanceData);
        }
    }, [VoucherFinanceData]);


    useEffect(() => {
        if (VoucherKarmaData && reportName === REPORT_NAME.VOUCHER_KARMA) {
            setDatasource(VoucherKarmaData);
        }
    }, [VoucherKarmaData]);


    useEffect(() => {
        if (partyCategoryData && reportName === REPORT_NAME.PARTY_CATEGORY_MASTER) {
            setDatasource(partyCategoryData);
        }
    }, [partyCategoryData]);


    return (
        <div className="mt-2 overflow-y-auto">
            <div className="d-flex flex-column flex-sm-row align-items-start align-items-sm-center justify-content-between mb-2">

                {/* Left: Report Name */}
                <div className="d-flex align-items-center w-100 w-sm-auto px-2 mb-2 mb-sm-0">
                    <h5
                        className="m-0 px-0 d-flex align-items-center text-accent"
                        style={{ fontWeight: "700" }}
                    >
                        {reportName === REPORT_NAME.USER_SUBSCRIBER ? "Subscriber" : reportName}
                    </h5>
                </div>

                {/* Right: Filters + Button */}
                <div className="d-flex flex-column flex-sm-row align-items-start align-items-sm-center justify-content-end gap-2 w-100">

                    {/* Date Range */}
                    {(reportName === REPORT_NAME.VOUCHER_FINANCE ||
                        reportName === REPORT_NAME.VOUCHER_KARMA) && (
                            <div className="w-100 w-sm-auto">
                                <RangePicker
                                    value={dateRange}
                                    onChange={(dates) =>
                                        handleFilterChange({
                                            dateRange: dates as [Dayjs | null, Dayjs | null],
                                        })
                                    }
                                    format="YYYY-MM-DD"
                                    placeholder={["From Date", "To Date"]}
                                    className="w-100"
                                />
                            </div>
                        )}


                    {/* Search */}
                    <div className="w-100 w-sm-auto">
                        <div className="input-group w-100">
                            <Form.Control
                                type="search"
                                placeholder="Search"
                                className="border-0 bg-cm-light-primary1"
                                aria-label="Search"
                                value={searchText}
                                onChange={(e) => handleFilterChange({ searchText: e.target.value })}
                            />
                            <div className="input-group-append bg-cm-light-primary1 p-1 rounded-end">
                                <span className="input-group-text bg-cm-light-primary1 border-0">
                                    <BsSearch className="bg-cm-light-primary1 border-cm-light-primary1" />
                                </span>
                            </div>
                        </div>
                    </div>

                    {/* Add Button */}
                    <div onClick={handleShow} className="d-flex px-2 align-items-center mt-1">
                        <Button
                            className="d-flex align-items-center me-0 text-nowrap bg-accent"
                        // onClick={() => {
                        //     setActionType(ACTION_TYPE.ADD_ACTION);
                        // }}
                        >
                            <BsPlus />
                            Add
                        </Button>
                    </div>
                </div>

                {/* Loader */}
                {getAllVoucherTypeFinanceMasterWithPaginationResponse.isLoading ||
                    getAllVoucherTypeKarmaMasterWithPaginationResponse.isLoading ||
                    getAllVoucherFinanceWithPaginationResponse.isLoading ||
                    getAllVoucherKarmaWithPaginationResponse.isLoading ||
                    getAllVoucherParticipantWithPaginationResponse.isLoading ||
                    getAllPartyCategoryMasterWithPaginationResponse.isLoading ||
                    getVoucherTypeKarmaMastersBySearchResponse.isLoading ||
                    getVoucherTypeFinanceMastersBySearchResponse.isLoading ||
                    getVoucherTypeKarmaBySearchResponse.isLoading ||
                    getVoucherTypeFinanceBySearchResponse.isLoading ||
                    getVoucherParticipantBySearchResponse.isLoading ||
                    getAllPartyCategoryMasterBySearchResponse.isLoading ||
                    deleteVoucherTypeKarmaMasterResponse.isLoading ||
                    deleteVoucherTypeFinanceMasterResponse.isLoading ||
                    deleteVoucherKarmaResponse.isLoading ||
                    deleteVoucherFinanceResponse.isLoading ||
                    deleteVoucherParticipantResponse.isLoading ||
                    deletePartyCategoryMasterResponse.isLoading ? (
                    <Loading />
                ) : (
                    ""
                )}

                {/* Modal */}
                {show && (
                    <VoucherTransactionReportData
                        show={show}
                        setShow={setShow}
                        actionType={actionType}
                        reportName={reportName}
                        data={selectedRow}
                        setCall={setCall}
                    />
                )}
            </div>

            <div className="mt-3 my-2 w-100 overflow-x-auto rounded-3">
                <Table
                    bordered={true}
                    rowKey={"id"}
                    pagination={{
                        total: (() => {
                            switch (reportName) {
                                case REPORT_NAME.VOUCHER_TYPE_MASTER_FINANCE:
                                    return totalVoucherTypeFinanceMaster;
                                case REPORT_NAME.VOUCHER_TYPE_MASTER_KARMA:
                                    return totalVoucherTypeKarmaMaster;
                                case REPORT_NAME.VOUCHER_FINANCE:
                                    return totalVoucherFinance;
                                case REPORT_NAME.VOUCHER_KARMA:
                                    return totalVouchereKarma;
                                case REPORT_NAME.VOUCHER_PARTICIPANT:
                                    return totalVoucherParticipant;
                                case REPORT_NAME.PARTY_CATEGORY_MASTER:
                                    return totalPartyCategoryMaster;
                                default:
                                    return [];
                            }
                        })(),
                        // hideOnSinglePage: true,  
                        responsive: true,
                        current: currentpage,
                        // showSizeChanger: true,  
                        pageSizeOptions: [10, 20, 30],
                        onChange: (page, pageSize) => {
                            paginationChange(page, pageSize);
                        },
                        pageSize: pageSize,
                    }}
                    columns={columData}
                    dataSource={dataSource}
                />
            </div>
        </div>
    );
};
export default VoucherTransactionReports;